import React, { Component } from 'react';
import { connect } from 'react-redux';

import { PAGE_ROUTES } from '../../constants/pageRoutes';

const mapStateToProps = state => ({
  global: state.Global
});

class HeaderButtonsResponsive extends Component {
  constructor(props) {
    super(props);

    this.onLinkRedirect = this.onLinkRedirect.bind(this);
  }

  onLinkRedirect = () => {
    const nav = document.getElementById('site-navigation');
    if (!!nav)
      nav.className = nav.className.replace('toggled', '');
  }

  render() {
    const { token } = this.props.global;
    return (
      <div>
        {
          !token ?
            <div class="resposive-signin-class">
              <a className="btn primary signin-btn-responsive" onClick={this.onLinkRedirect} href={`/app/#${PAGE_ROUTES.LOGIN}`}>Sign In</a>
              <a className="btn primary signup-btn-responsive" onClick={this.onLinkRedirect} href={`/app/#${PAGE_ROUTES.CREATE_ACCOUNT}`}>Sign Up</a>
            </div>
            : <a className="btn primary logout-btn-responsive" onClick={this.onLinkRedirect} id="mobile-logout" href={`/app/#${PAGE_ROUTES.LOGOUT}`}>Log Out</a>
        }
      </div>
    )
  }
}

export default connect(mapStateToProps)(HeaderButtonsResponsive);
